




















































import { defineComponent, computed, ref, onUnmounted } from '@vue/composition-api';
import { DropdownOption } from 'tdesign-vue';
import { SoundIcon } from 'tdesign-icons-vue';
import filterXSS from 'xss';
import Login from '@/renderer/components/login/components/index.vue';
import SettingDialog from '@/renderer/components/dialog/setting/index.vue';
import PrivateClientDownloadDialog from '@/renderer/components/browser/PrivateClientDownloadDialog/index.vue';
import { i18n_t, LanguageOptions } from '@/locales/i18n';
import tips from '@/renderer/scripts/utils/tips';
import { getDeviceName } from '@/renderer/scripts/utils/tools/index';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import ipc, { IpcEvents } from '@/renderer/scripts/utils/ipc';
import { setLanguage } from '@/locales/languageSettingMethod';
import { decodeText } from '@/renderer/scripts/utils/tools/packages/encrypt';
import { IS_PRIVATE } from '@/common/constant';
import { windowEnvs } from '@/renderer/scripts/utils/ConstantConfig/PrivateConfig';

export default defineComponent({
  components: {
    Login,
    SettingDialog,
    SoundIcon,
    PrivateClientDownloadDialog,
  },
  setup(props, context) {
    const vm = context.root;
    const store = context.root.$store;
    // 查询参数
    const showInMobile = computed(() => store.getters.isMobile || store.getters.isMobileStyle);
    const showSetting = ref(false);
    const titleTextColor = windowEnvs.loginTitleTextColor;
    const sloganTextColor = windowEnvs.loginSloganTextColor;

    const languageOptions = ref(LanguageOptions);
    const languageOptionsMobile = ref(LanguageOptions);
    const loginLoading = () => {
      let timer: any = setTimeout(() => {
        store.commit('setLoginingMask', false);
        clearTimeout(timer);
        timer = null;
      }, 500);
    };

    const loginComponentHeight = ref('516px');
    const showPrivateClientDownloadDialog = ref(false);

    const onLoginComponentHeightChange = (height: number) => {
      loginComponentHeight.value = `${height}px`;
    };

    const CopyrightText = computed(() => {
      if (IS_PRIVATE && windowEnvs.copyRight) {
        const html = filterXSS(windowEnvs.copyRight);
        return html;
      }
      const thisYear = new Date().getFullYear();
      return `Copyright @ 2022-${thisYear} Tencent. All Rights Reserved`;
    });
    const methods = {
      // 登录成功后执行
      logined({ loginPath }: { loginPath: string }) {
        tips.success(i18n_t('登录成功'));
        // 三方登录重定向后会携带path path进行了先加密再2次encodeURI 这里需要反解一下
        let routePath = decodeText(decodeURIComponent(decodeURIComponent(loginPath)));
        if (!routePath) {
          // 解密失败 兜底使用原loginPath
          routePath = loginPath;
        }
        if (routePath && routePath !== '/login') {
          dispatchRouter({ path: routePath }, 'replace');
        } else {
          let routerName = store.getters.isMobileStyle ? 'recentUse' : 'workbench';
          // 若登录时企业已过期自动跳转至过期页面
          if (store.getters.orgExpired) {
            routerName = 'teamExpired';
          }
          dispatchRouter(
            {
              name: routerName,
            },
            'replace',
          );
        }
        loginLoading();
      },
      // 统计来源
      reportSource() {
        reporter.report('browser_type', {
          browser_type: getDeviceName(),
        });
        const { source, type, uid } = vm.$route.query;
        // uid非必须
        if (source && type) {
          reporter.report('enter_login', {
            source: source || '',
            uid: uid || '',
            type: type || '',
          });
        }
      },
      // 响应托盘菜单消息
      onTrayMenuEvent(e: Event, params: any) {
        const { event } = params;
        switch (event) {
          case 'update':
            ipc.emit(ipc.RENDERER_EVENTS_MAP.CHECK_UPDATE);
            break;
          case 'setting':
            showSetting.value = true;
            break;
          default:
            break;
        }
      },
      onLanguageChange(dropdownItem: DropdownOption) {
        setLanguage(dropdownItem.value as string);
      },
    };
    methods.reportSource();
    ipc.on(IpcEvents.MENU_CLICK, methods.onTrayMenuEvent);
    onUnmounted(() => {
      ipc.off(IpcEvents.MENU_CLICK, methods.onTrayMenuEvent);
    });
    return {
      titleTextColor,
      sloganTextColor,
      CopyrightText,
      showInMobile,
      showSetting,
      languageOptions,
      languageOptionsMobile,
      onLoginComponentHeightChange,
      loginComponentHeight,
      dispatchRouter,
      showPrivateClientDownloadDialog,
      ...methods,
    };
  },
});
